import { render } from "./FormSelect.vue?vue&type=template&id=23dcd4d6&scoped=true"
import script from "./FormSelect.vue?vue&type=script&lang=js"
export * from "./FormSelect.vue?vue&type=script&lang=js"

import "./FormSelect.vue?vue&type=style&index=0&id=23dcd4d6&scoped=true&lang=css"

import exportComponent from "/Users/rs/Development/alisops/aclu-or-form/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23dcd4d6"]])

export default __exports__